<script>
  import VStepperStep from 'vuetify/es5/components/VStepper/VStepperStep'
  import VIcon from 'vuetify/es5/components/VIcon/VIcon'

  export default {
    name: 'v-stepper-step',
    extends: VStepperStep,
    props: ['stepName'],

    computed: {
      hasError: function hasError () {
        let that = this
        return this.rules.some(function (i) {
          return i(that) !== true
        })
      }
    },

    methods: {
      toggle: function toggle (step) {
        this.isActive = step.toString() === this.step.toString()
        this.isInactive = Number(step) < Number(this.step)
      }
    },

    render (h) {
      // console.log(`Render step ${this.step}`)

      const data = {
        'class': this.classes,
        directives: [{
          name: 'ripple',
          value: this.editable
        }],
        on: { click: this.click },
        'style': 'text-decoration: none;'
      }
      let stepContent

      if (this.hasError) {
        stepContent = [h(VIcon, {}, this.errorIcon)]
      } else if (this.complete) {
        const iconData = {
          class: {
            'fa-sm': true
          },
          style: {
            fontSize: 'inherit'
          }
        }

        if (this.isActive) {
          stepContent = [h(VIcon, iconData, this.editIcon)]
        } else {
          stepContent = [h(VIcon, iconData, this.completeIcon)]
        }
      } else {
        stepContent = this.step
      }

      const step = h('span', {
        staticClass: 'v-stepper__step__step',
        'class': {
          [this.color]: !this.hasError && (this.complete || this.isActive)
        }
      }, stepContent)

      const label = h('div', {
        staticClass: 'v-stepper__label'
      }, this.$slots.default)

      return h('a', data, [step, label])
    },

    mounted () {
      // console.log('this.complete', this.complete)
    }

  }
</script>
